import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import Login from "@/pages/Login.vue";
import Register from "@/pages/Register.vue";
import Overview from "@/pages/Overview.vue";
import Model from "@/pages/Model.vue";
import Forgot from "@/pages/Forgot.vue";
import Profile from "@/pages/Profile.vue";
import ApiKeys from "@/pages/ApiKeys.vue";

const routes = [
  {
    path: "/",
    name: "landing",
    redirect: "/overview",
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/overview",
    name: "overview",
    component: Overview,
    meta: { requiresAuth: true },
  },
  {
    path: "/forgot",
    name: "forgot",
    component: Forgot,
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/api-keys",
    name: "api-keys",
    component: ApiKeys,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/model/:id",
    name: "model",
    component: Model,
    meta: { requiresAuth: true },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/overview",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  // Wait for auth to be initialized before proceeding
  if (!store.getters.isAuthInitialized) {
    // Create a promise that resolves when auth is initialized
    await new Promise((resolve) => {
      const unwatch = store.watch(
        (state) => state.authInitialized,
        (value) => {
          if (value) {
            unwatch();
            resolve();
          }
        },
      );
    });
  }

  const requiresAuth = to.meta.requiresAuth;
  const isAuthenticated = store.getters.isAuthenticated;

  if (requiresAuth && !isAuthenticated) {
    next("/login");
  } else {
    next();
  }
});

export default router;
